<template lang="pug">

	b-card.mb-4(no-body)
		b-card-header
			h4(style="font-weight:400;") Изменить изображение профиля
		b-card-body
			Alerts(ref="Alerts")
			b-form(@submit.prevent='onSubmit')

				component(:is="field.widget" v-model="form[field.name]" v-for="field in formAvatar" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

				b-button.d-flex.align-items-center(type='submit' variant='primary' :disabled="account.isFetching")
					b-spinner.mr-2(label="Loading..." small v-if="account.isFetching")
					| Сохранить изменения

</template>

<script type="text/babel">
	import { mapState} from 'vuex'
	import Alerts from '../../components/Alerts'

	import formBackValidationMixin from '@/MIXINS/formBackValidation';
	import collectFormData from '@/MIXINS/collectFormData';
	import clearForm from '@/MIXINS/clearForm';

	import formAvatar from '@/store/forms/formAvatar'

	export default {
		name: "change-password",
		components: {
			Alerts
		},
		mixins: [
			formBackValidationMixin,
			collectFormData,
			clearForm,
		],
		data: () => ({
			defaultAvatar: '/img/placeholders/avatar.png',
			formAvatar,
		}),
		computed: {
			...mapState(['account']),

			error(){ return this.account.error },
			form(){
				const { avatar } = this.account.data;
				return { avatar } || {}
			}
		},
		methods: {
			onSubmit() {
				this.$store.dispatch('patchAccount', this.collectFormData(this.form))
					.then( this.successFormHandler )
					.catch( this.errorFormHandler );
			},
			successFormHandler(){
				this.error
					? this.errorFormHandler(this.error)
					: this.$refs.Alerts.showAlert('Изображение профиля успешно обновлено!', 'success') || this.clearForm();
			},
			errorFormHandler(error){
				this.$refs.Alerts.showAlert(error.non_field_errors ? error.non_field_errors[0] : '', 'error')
			},
		},
	}
</script>
